module.exports = __webpack_public_path__ + "static/media/pear_bodytype.23879d6e.png";